import React, {cloneElement} from 'react';
import styled, {css} from "styled-components";


// Styles ----------------------------------------------------------------
// -----------------------------------------------------------------------
const StyledTable = styled.table`
    display: flex;
    flex-flow: row nowrap;
    width: ${({$width}) => $width ? $width : '100%'};
    height: ${({$height}) => $height ? $height : 'auto'};
    margin: ${({$margin}) => $margin ? $margin : 'auto'};
    padding: ${({$padding}) => $padding ? $padding : 'auto'};
    border: 2px solid ${({$borderColor}) => $borderColor ? $borderColor : 'transparent'};
    border-radius: ${({$borderRadius}) => $borderRadius ? $borderRadius : '0'};
`

const StyledTableBody = styled.tbody`
    display: block;
    flex-flow: row nowrap;
    width: 100%;
`

const StyledTableRow = styled.tr`
    display: flex;
    flex-flow: row nowrap;
    width: 100%;
    margin: ${({$margin}) => $margin ? $margin : 'auto'};
    padding: ${({$padding}) => $padding ? $padding : 'auto'};
    border-bottom: 2px solid ${({$separatorColor}) => $separatorColor ? $separatorColor : 'transparent'};
    ${({$hoverColor}) => $hoverColor ? `&:hover { background: ${$hoverColor}` : ''}
`

const _CELL_STYLE = css`
    display: flex;
    width: ${({$span}) => $span ? $span : undefined};
    margin: ${({$margin}) => $margin ? $margin : 'auto'};
    padding: ${({$padding}) => $padding ? $padding : 'auto'};
    gap: ${({$gap}) => $gap ? $gap : 'auto'};
    text-align: ${({$halign}) => $halign ? $halign : 'left'};
    justify-content: ${({$halign}) => $halign ? $halign : 'left'};
    align-items: ${({$valign}) => $valign ? $valign : 'top'};
    ${({$shouldHover}) => $shouldHover ? '&:hover { background: silver }' : ''}
`

const StyledTableHeader = styled.th`${_CELL_STYLE}`
const StyledTableCell = styled.td`${_CELL_STYLE}`
// -----------------------------------------------------------------------
// -----------------------------------------------------------------------


// Components ------------------------------------------------------------
// -----------------------------------------------------------------------
const Table = ({children, width, height, margin, padding, borderColor, borderRadius, ...rest}) => {
    return <StyledTable
        $width={width} $height={height} $margin={margin} $padding={padding}
        $borderColor={borderColor} $borderRadius={borderRadius}
        {...rest}
    >
        <StyledTableBody>
            {children}
        </StyledTableBody>
    </StyledTable>
}

const Row = ({children, margin, padding, ...rest}) => {
    // children prop is often not an array, check if it has a length
    const valid_children = React.Children.toArray(children).filter(
        (c) => React.isValidElement(c)
    );
    const total_span = !valid_children?.length ? 1
        : valid_children.reduce(
            (total, c) => (total + (c.props?.span ?? 1)), 0
        );
    const newChildren = valid_children.map((c) => {
        return cloneElement(c, {span: `${100 * (c.props.span ?? 1) / total_span}%`});
    })
    return <StyledTableRow $margin={margin} $padding={padding} {...rest}>
        {newChildren}
    </StyledTableRow>
}

const Cell = ({header, span, margin, padding, gap, halign, valign, shouldHover, children, ...rest}) => {
    const Style = header ? StyledTableHeader : StyledTableCell;
    return <Style
        $span={span} $margin={margin} $padding={padding}
        $gap={gap} $halign={halign} $valign={valign} $shouldHover={shouldHover}
        {...rest}
    >
        {children}
    </Style>
}
// -----------------------------------------------------------------------
// -----------------------------------------------------------------------

export {Table, Row, Cell};
